module.exports = __webpack_public_path__ + "public/images/prizes/arrow.b8d7363daa6d7a5c38ef793d1e555768.svg";